<template>
    <!-- thumbs with scrolling function -->
    <div :class="['tsComp','reveal']" ref="tScroller">
        <ul class="tsItems" :style="getCountStyle()" ref="thumbitems1">
            <li class="tsItem"
                v-for="(item, index) in items" 
                :style="getStyleIndex(index)"
                :key="index">

                <div class="tsInner">
                    <div class="tsQuotes">
                        <img src="img/svg/quotes.svg" >
                    </div>
                    <div class="tsContent">
                        <!-- <splitter :startDelay="0.5*index" :content="localize(item.content)"></splitter> -->
                        {{item.content}}
                    </div>
                    <div class="tsBottom">
                        <div class="tsImg">
                            <img :src="item.img">
                        </div>
                        <div class="tsName">
                            <span>{{item.title}}</span>
                            <span>{{item.subtitle}}</span>
                        </div>
                    </div>
                </div>

            </li>          
        </ul>
    </div>
</template>

<style scoped>
    .tsComp
    {
        clear: both;        
        width: 100%;
        /*
        overflow-x:scroll;
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: none;
        scrollbar-width: none;
        */
    }
    .tsComp::-webkit-scrollbar {
      display: none; /* Chrome, Safari and Opera */
    }
    .tsComp .tsItems
    {
        height: auto;
        width:90vw;
        list-style: none;  
        display: flex;
        justify-items: center;
        align-items: top;
        gap: 30px;        
    }
    .tsComp .tsItem    
    {
        opacity: 0;
        transition: all ease 0.6s;
        transition-delay: calc(0.5s + (0.15s * var(--index)));
        transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);   
        transform:translateY(120px) /* rotate(5deg) */;
        width: 30vw;
    }
    .tsComp.active .tsItem
    {
        opacity: 1;
        /* transition-delay: calc(1.2s + (0.09s * var(--index))); */
        /* transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);     */
        transform:translateY(0px);
    }



    .tsInner   
    {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 45vh;
        min-height: 440px;
        transition: all ease-in 0.2s;
        /* transition-delay: calc(1.2s + (0.09s * var(--index))); */
        /* transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);     */
        overflow: hidden;
        
        padding: 40px 50px 30px 50px;

        /* background-color: #fff; */
        background-color: rgba(255,255,255,1); 


    }    
    .tsQuotes
    {
        text-align: center;
        padding-bottom: 10px;
    }
    .tsQuotes img
    {
        width: 50px;
        height: auto;
        margin: auto;
    }
    .tsContent
    {
        font-size: 22px;
        text-align: left;
        flex: auto;
        position: relative;
    }
    .tsBottom .tsImg
    {
        float: left;
        padding-right: 15px;
    }
    .tsImg img
    {
        width: 50px;
        height: 50px;
        border: solid 2px #fff;
        border-radius: 100%;
    }
    .tsBottom .tsName
    {
        float: left;
        position: relative;
        top: 5px;
    }
    .tsBottom .tsName span:nth-child(1)
    {
        font-weight: 600;
    }
    .tsBottom .tsName span
    {
        display: block;
    }

    @media (hover:hover)
    {
        /* SET INTERACTIVE MODE */
        .tsInner:hover
        {
            background-color: #ffffff;
            color:var(--blue-main);
            /* color:#fff; background-color: #0075be;*/
        }
    }

    @media (max-width: 1200px) { 
        .tsInner
        {
            min-height: 380px;
        }
        .tsContent
        {
            font-size: 20px;
        }
    }    

    @media (max-width: 850px) { 
        .tsComp .tsItems
        {
            display: block;
        }
        .tsComp .tsItem
        {
            width: 100%;
            padding: 10px 0px;
        }
        .tsInner
        {
            padding: 40px 30px 30px 30px;
            background-color: #f8f8f8;
            height: auto;
            min-height: initial;
        } 
        .tsBottom
        {
            padding-top: 20px;
        }       


        .tsBottom .tsImg{
            float: left;
            padding-right: 15px;
            text-align: center;
            width: 100%;
        }        
        .tsImg img{
            width: 120px;
            height: 120px;
            border: solid 2px #fff;
            border-radius: 100%;
            display: block;
            margin: auto;
        }
        .tsBottom .tsName{
            float: none;
            position: relative;
            top: 5px;
            display: block;
            clear: both;
            width: 100%;
            text-align: center;
        }        
    }



    @media (max-width: 400px) { 

    }

    /* Portrait iPad mini 1, iPad 1 and iPad 2*/
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: portrait)
    {

    }    
</style>
<script>
import { splitLines,isMobileScreen } from "@/utils";
import sidepager from "@/views/com/sidepager.vue";
import splitter from "@/views/com/splitter.vue";
export default {
    components:{splitter,sidepager},
    props: {
        items:{
            default: () => [],type:Array
        },
        pageIndex:
        {
            default:0,
            type:Number
        },
        bgsize:
        {
            default:'cover',
            type:String
        },
        hoverIcon:
        {
            //:hoverIcon="fal fa-plus"
            default:'fal fa-play',
            type:String
        },
        contentIndex:
        {
            default:0,
            type:Number
        },
        imgPadding:
        {
            default:'0px',type:String
        },
        interactive:
        {
            //tells the component to switch css hover modes 
            default:false,type:Boolean
        }
    },
    data()
    {
        return {
            isMobile:false
        }
    },
    mounted()
    {
        //this.initScrollListener();
        this.isMobile = isMobileScreen();
    },
    methods:{
        getCountStyle(){
            return "--itemscount:"+this.items.length;
        },
        getStyleIndex(index){
            return "--index:"+index+";--imgPadding:"+this.imgPadding;
        }
    },
    watch:{
        pageIndex:function(newVal,oldVal)
        {
            //scroll to the page by it's size
            //alert("change newVal="+newVal);
            this.navToPage(newVal);
        },
        interactive:function(newVal,oldVal)
        {
            //alert("interactive="+interactive);
            //this.isInteractive = newVal;
        }
    },


};
</script>

